import { SortDirection } from '../../../Types/SortDirection';

export enum ViewMode {
  ALL_ASSOCIATES = 'all_associates',
  INDIVIDUAL_ASSOCIATE = 'individual_associate',
}

export interface TrainingRecord {
  id: string;
  associateName: string;
  associateId: string;
  courseName: string;
  courseLink: string;
  ccxAttributes: string[];
  completionStatus: TrainingCompletionStatus;
  dueDate: string;
  duration: number; // in minutes
  assignedDate: string;
  completedDate?: string;
  latestTranscriptTimestamp?: string;
}

export enum ViewContext {
  CSA = 'CSA',
  TM = 'TM',
}

export const TrainingTableEmptyStateDataTestIds: Record<ViewContext, string> = {
  [ViewContext.TM]: 'tm-trainings-table-empty-state',
  [ViewContext.CSA]: 'csa-training-table-empty-state',
};

export enum TrainingStatus {
  PENDING_ASSIGN = 'PENDING_ASSIGN',
  ASSIGNED = 'ASSIGNED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  OVERDUE = 'OVERDUE',
}

export enum TrainingCompletionStatus {
  NOT_STARTED = 'Not Started',
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
  OVERDUE = 'Overdue',
}

export interface DirectReport {
  id: string;
  name: string;
  alias: string;
  trainingCount: number;
}

export interface TrainingTableProps {
  trainings: TrainingRecord[];
  loading: boolean;
  error?: string;
  sortColumn: TrainingTableSortColumn;
  sortDirection: SortDirection;
  onSort: (column: TrainingTableSortColumn, direction: SortDirection) => void;
  currentPage: number;
  itemsPerPage: number;
  totalItems: number;
  onPageChange: (page: number) => void;
}

export enum TrainingTableSortColumn {
  ASSOCIATE_NAME = 'associateName',
  COURSE_NAME = 'courseName',
  CCX_ATTRIBUTE = 'ccxAttribute',
  ASSIGNED_DATE = 'assignedDate',
  COMPLETION_STATUS = 'completionStatus',
  DUE_DATE = 'dueDate',
  DURATION = 'duration',
}

export interface TrainingDataResponse {
  trainings: TrainingRecord[];
  directReports: DirectReport[];
  lastUpdated: string;
}

// API Response Types
export interface ApiTrainingRecord {
  assignedDate: string;
  assignmentId: string;
  assignorId: string;
  dueDate: string;
  latestTranscriptTimestamp?: string;
  status: string;
  trainingCatalog: ApiTrainingCatalog;
  userAlias: string;
  userId: string;
}

export interface ApiTrainingCatalog {
  auditTime: string;
  deepLink: string;
  duration: string; // ISO 8601 format like "PT0H0M0S"
  latestVersion: boolean;
  learnTrainingId: string;
  lms: string;
  media: ApiMedia;
  metrics: string[];
  multilingualAttributes: ApiLanguageAttributes[];
  trainingLanguage: string | null;
  version: number;
}

export interface ApiMedia {
  thumbnailAltText: string;
  thumbnailImage: string;
}

export interface ApiLanguageAttributes {
  description: string;
  isDefaultLanguage: boolean;
  keywords: string;
  languageId: string;
  trainingTitle: string;
}

export interface AssignedTrainingsResponse {
  records: ApiTrainingRecord[];
}

export const API_STATUS_MAPPING: Record<string, TrainingCompletionStatus> = {
  COMPLETED: TrainingCompletionStatus.COMPLETED,
  IN_PROGRESS: TrainingCompletionStatus.IN_PROGRESS,
  NOT_STARTED: TrainingCompletionStatus.NOT_STARTED,
  OVERDUE: TrainingCompletionStatus.OVERDUE,
};
